module.exports = {"yytx03":{"daobanList":[{"title":"1:是否办理失业保险金申领","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1 失业保险待遇申请表","state":"必要"},{"name":"2 社会保障卡或身份证","state":"必要"},{"name":"3 个人委托书","state":"非必要"},{"name":"4 解除或终止劳动关系证明材料","state":"必要"},{"name":"5 代办人身份证","state":"非必要"},{"name":"6 中华人民共和国外国人永久居留身份证","state":"必要"},{"name":"7 失业登记","state":"非必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx03.json
// module id = 1302
// module chunks = 0